export function getAbbreviationFromString(item: string) {
    const initials = item.split(" ");
    if (initials.length === 1) {
        return initials[0].substring(0, 1);
    }
    return initials[0].substring(0, 1) + initials[initials.length - 1].substring(0, 1);
}

export function padLeft(str: string, targetLength: number, padString: string) {
    if (str.length >= targetLength) {
        return str;
    }

    while (str.length < targetLength) {
        str = padString + str;
    }

    return str;
}

export function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
